'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.close = close;
exports.open = open;
exports.setActiveIndex = setActiveIndex;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OPEN = 'galleryViewer/OPEN';
var CLOSE = 'galleryViewer/CLOSE';
var SET_ACTIVE_INDEX = 'galleryViewer/SET_ACTIVE_INDEX';

var initialState = {
  isGalleryOpen: false,
  media: [],
  activeIndex: 0
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case OPEN:
      return (0, _extends3.default)({}, initialState, { isGalleryOpen: true, media: action.media });
    case CLOSE:
      return (0, _extends3.default)({}, initialState);
    case SET_ACTIVE_INDEX:
      return (0, _extends3.default)({}, state, { activeIndex: action.activeIndex });
    default:
      return state;
  }
}

function close() {
  return {
    type: CLOSE
  };
}

function open(media) {
  return {
    type: OPEN,
    media: media
  };
}

function setActiveIndex(activeIndex) {
  return {
    type: SET_ACTIVE_INDEX,
    activeIndex: activeIndex
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/modules/galleryViewer.js
// module id = 280
// module chunks = 0